import React, { useContext } from 'react';

import Button from '@mui/material/Button';
import Box from '@mui/material/Box';

import { AppConfigContext } from '@providers/AppConfigProvider';

interface CustomButtonProps {
  href: string;
  label: string;
  handleClick: () => void;
}

export default function CustomButton({ href, label, handleClick }: CustomButtonProps): React.JSX.Element {
  const { pathRoot } = useContext(AppConfigContext);
  return (
    <Button component="a" href={href} className="relative p-0" onClick={handleClick}>
      <Box className="relative rf-btn-black-md hover:text-rf-black hover:bg-rf-yellow group">
        <span className="absolute left-1/2 transform -translate-x-1/2 text-white group-hover:text-black">{label}</span>
        <img
          src={`${pathRoot}/assets/images/common/ArrowForwardRoundedIcon_black.svg`}
          className="absolute top-[18px] right-4 w-5 hidden group-hover:block"
          alt="arrow"
        />
      </Box>
    </Button>
  );
}
